<template>
  <div>
    <v-container>
      <p class='mb-7'>
        Every irrigation estimate starts with the default printout values. However, you can edit all fields as you see fit for this specific estimate.
        You can preview the printout by clicking "Preview" from the burger menu in the top right.<br>
      </p>
      <v-alert type='info' border='left'>Don't forget to click save at the bottom!</v-alert>
      <v-form v-model='isFormValid'>
        <v-row>
          <v-col cols='12'>
            <v-text-field
              label='General Description'
              v-model='estimateDetailCopy.general_description'
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols='4'>
            <v-textarea
              label='Specific Description'
              outlined
              rows='3'
              v-model='estimateDetailCopy.specific_desc_1'
            ></v-textarea>
          </v-col>
          <v-col cols='1' class='text-center'>
            <v-textarea
                style="font-size: 30px;"
                label="Number of Smalls"
                outlined
                rows="3"
                v-model="estimateDetail.smalls"
            ></v-textarea>
          </v-col>
          <v-col cols='3'>
            <v-textarea
              outlined
              rows='3'
              v-model='estimateDetailCopy.specific_desc_2'
              hint='This will hide if number of smalls = 0'
              persistent-hint
            ></v-textarea>
          </v-col>
          <v-col cols='1' class='text-center'>
            <v-textarea
                style="font-size: 30px;"
                label="Number of Bigs"
                outlined
                rows="3"
                v-model="estimateDetail.bigs"
            ></v-textarea>
          </v-col>
          <v-col cols='3'>
            <v-textarea
              outlined
              rows='3'
              v-model='estimateDetailCopy.specific_desc_3'
              hint='This will hide if number of bigs = 0'
              persistent-hint
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols='12'>
            <v-textarea
              label='Initial Preparation'
              v-model='estimateDetailCopy.initial_prep'
              rows='2'
              outlined
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols='12'>
            <v-text-field
              label='Heads'
              v-model='estimateDetailCopy.heads_desc'
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols='12'>
            <v-text-field
              label='Pipe'
              v-model='estimateDetailCopy.pip_desc'
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols='4'>
            <v-textarea
              outlined
              rows='3'
              v-model='estimateDetailCopy.controller_desc_1'
              label='Controller'
            ></v-textarea>
          </v-col>
          <v-col cols='4'>
            <v-textarea
              outlined
              rows='3'
              v-model='estimateDetailCopy.controller_location'
              label='Controller'
            ></v-textarea>
          </v-col>
          <v-col cols="4">
            <v-textarea
              outlined
              rows='3'
              v-model='estimateDetailCopy.controller_desc_2'
              label='Controller'
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols='12'>
            <v-textarea
            label="Mechanical Statement"
            rows='3'
            outlined
            v-model='estimateDetailCopy.mech_contractor'
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols='mechanicalColumns'>
            <v-textarea
              label='Mechanical'
              outlined
              rows='3'
              v-model='estimateDetailCopy.mech_desc_1'
            ></v-textarea>
          </v-col>
          <template v-if='!estimate.is_comm'>
            <v-col cols='4'>
              <v-textarea
                label='Mechanical'
                outlined
                rows='3'
                v-model='estimateDetailCopy.mechanical_side'
              ></v-textarea>
            </v-col>
            <v-col cols='4'>
              <v-textarea
                label='Mechanical'
                outlined
                rows='3'
                v-model='estimateDetailCopy.mech_desc_2'
              ></v-textarea>
            </v-col>
          </template>
        </v-row>
        <v-row>
          <v-col cols='12'>
            <h3 class='mb-4'>Finishing Options</h3>
            <v-textarea
              label='Finishing 1'
              outlined
              rows='2'
              v-model='estimateDetailCopy.finishing_desc_1'
            ></v-textarea>
            <v-textarea
              label='Finishing 3'
              outlined
              rows='2'
              v-model='estimateDetailCopy.finishing_desc_3'
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols='12'>
            <h3 class='mb-4'>Special Notes</h3>
            <v-textarea
              label='Special Notes 1'
              outlined
              rows='2'
              v-model='estimateDetailCopy.special_note_4'
            ></v-textarea>
            <v-textarea
              label='Special Notes 2'
              outlined
              rows='2'
              v-model='estimateDetailCopy.special_note_5'
            ></v-textarea>
            <v-textarea
              label='Special Notes 3'
              outlined
              rows='2'
              v-model='estimateDetailCopy.special_note_6'
            ></v-textarea>
            <v-textarea
              label='Special Notes 4'
              outlined
              rows='2'
              v-model='estimateDetailCopy.special_note_1'
            ></v-textarea>
            <v-textarea
              label='Special Notes 5'
              outlined
              rows='2'
              v-model='estimateDetailCopy.special_note_2'
            ></v-textarea>
            <v-textarea
              label='Special Notes 6'
              outlined
              rows='2'
              v-model='estimateDetailCopy.special_note_3'
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols='12' class='text-right'>
            <v-btn
              xLarge
              relative
              right
              color='success'
              @click='save'
              :loading='isSaving'
              :disabled='!isFormValid'
            >
              <v-icon large>mdi-check</v-icon>
              Save
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import estimatesAPI from '@/modules/estimates/api/estimates'
import formRules from '@/mixins/formRules'
import _ from 'lodash'

export default {
  name: 'irrigation-estimate-printout',
  mixins: [formRules],
  props: {
    estimate: {
      required: true
    }
  },
  data: () => ({
    isLoading: true,
    isFormValid: false,
    isSaving: false,
    showEditBox: false,
    estimateDetail: null,
    estimateDetailCopy: null,
    lines: []
  }),
  computed: {
    stackComesOut () {
      return this.$store.state.misc.globalOptions.estimateStackOptions
    },
    mechanicalColumns() {
      if(this.estimate.is_comm){
        return 12;
      }
      else {
        return 4;
      }
    }
  },
  created () {
    console.log(this.estimate)
    this.getData()
  },
  methods: {
    async getData() {
      this.isLoading = true
      this.estimateDetail = _.cloneDeep(this.estimate.estimate_detail)
      this.estimateDetailCopy = _.cloneDeep(this.estimateDetail)
      console.log(this.estimateDetail)
      this.isLoading = false
    },
    async save () {
      this.isSaving = true
      this.estimateDetailCopy = await estimatesAPI.updateIrrigationEstimate(this.estimateDetailCopy)
      let estimateCopy = _.cloneDeep(this.estimate)
      estimateCopy.estimate_detail = this.estimateDetailCopy
      this.$emit('updateEstimateWithoutApiCall', estimateCopy)
      this.showEditBox = false
      this.isSaving = false
    },
    getSideDisplay (val) {
      if (this.stackComesOut.find(o => o.value === val) !== undefined) {
        return this.stackComesOut.find(o => o.value === val).text
      }
      return ''
    },
    getMechanicalSide(){
        if(this.estimateDetailCopy.mechanical_side === "F"){
            return "front ";
        }
        else if(this.estimateDetailCopy.mechanical_side === "B"){
            return "back ";
        }
        else if(this.estimateDetailCopy.mechanical_side === "L"){
            return "left side ";
        }
        else if(this.estimateDetailCopy.mechanical_side === "R"){
            return "right side ";
        }
        return "";
    },
  }
}
</script>

<style scoped>

.floating-save {
  right: 20px;
  bottom: 20px;
  position: fixed;
}
</style>
